<template>
  <div class="SinglePageDescription">
    <div class="BookingInstructions-div">
      <van-skeleton title :row="3" title-width="80" :loading="loading">
        <p class="Quick-reply">更多取票信息</p>
        <!-- <div
        v-for="(item, index) in supplier_voucher_details"
        :key="'info3' + index"
        class="BookingInstructions-padd"
      >
        <p class="BookingDetails-title">
          {{ item.key }}
        </p>
        <p v-html="item.value" class="BookingDetails-content"></p>
      </div> -->
        <div
          v-html="supplier_voucher_details"
          class="BookingInstructions-padd"
        ></div>
        <p
          v-if="
            supplier_voucher_details == '' ||
            supplier_voucher_details == null ||
            supplier_voucher_details == []
          "
          class="BookingDetails-information"
        >
          暂无信息
        </p>
      </van-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      supplier_voucher_details:
        "二维码：https://t.ctrip.cn/?tluPcuY/04E5.jpg ，凭证码：4583641336 ",
    };
  },
  mounted() {
    this.TicketDetails();
  },
  methods: {
    TicketDetails() {
      this.$api
        .post("third-tickets/member/order/detail", {
          order_sn: this.$route.query.order_sn,
        })
        .then((res) => {
          var url = res.order_ticket.supplier_voucher_details; //this.supplier_voucher_details;
          // 匹配链接的正则表达式
          var urlReg =
            /(http:\/\/|ftp:\/\/|https:\/\/|www.)[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/g;
          var array = url.match(urlReg);

          // 设置!!为临时占位符
          var rpStr = url.replace(urlReg, "!!");
          function insertLink(el, i, arr) {
            //匹配协议，因为Vuejs会对href属性自动加上' http:// '
            if (
              el.match("http://") ||
              el.match("ftp://") ||
              el.match("https://")
            ) {
              var link = '<a href="' + el + '">' + el + "</a>";
            } else {
              var link = '<a href="http://' + el + '">' + el + "</a>";
            }
            // console.log(rpStr)
            // console.log(links)
            // 将字符串里的!! 替换为link的内容并重新赋值给 rpStr
            rpStr = rpStr.replace("!!", link);
            // console.log('result',rpStr)
            return rpStr;
          }

          if (array != null) {
            array.forEach(insertLink);
          }
          this.supplier_voucher_details = rpStr;
          this.loading = false;
          // console.log(rpStr);

          //  this.supplier_voucher_details = res.order_ticket.supplier_voucher_details;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.SinglePageDescription {
  background: #fff;
  .van-skeleton {
    margin-top: 30px;
    padding-bottom: 10px;
    .van-skeleton__title {
      width: 90px;
      height: 25px;
      border-radius: 20px;
    }
    .van-skeleton__content {
      border-radius: 20px;
    }
    .van-skeleton__row {
      //  height: 50px;
      // margin: 17px 0px;
      border-radius: 20px;
    }
  }
  .Quick-reply {
    color: #333;
    font-weight: bold;
    padding-top: 25px;
    margin-bottom: 15px;
    padding-left: 20px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 20px;

    .BookingDetails-information {
      color: #666;
      font-size: 13px;
      font-weight: bold;
      padding-left: 20px;
    }
    .BookingInstructions-padd {
      padding: 0px 20px;
      margin-top: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 15px;
    }
    .BookingInstructions-padd:last-of-type {
      border-bottom: none;
    }
  }

  .BookingDetails-title {
    color: #333;
    font-size: 13px;
    font-weight: bold;
  }

  .BookingDetails-content {
    font-size: 13px;
    color: #999;
    line-height: 20px;
    background: #fff;

    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
</style>
